export default {
  debug: false,
  bingApiUrl:
    'https://www.bing.com/api/maps/mapcontrol?callback={callback}&key={credentials}',
}
